export default {"src":"/_next/static/media/italic_info_icon_blue.9ec6e401.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};